<template>
    <div class="subscription-plan" :class="[{'active': sub.type === type }, `subscription-plan-${color}`, {'disabled': disabled}]">
        <div class="subscription-header">
            <div class="subscription-logo">
                <i class="fal" :class="[imgIcon, color]" style="font-size:70px;"></i>
            </div>
        </div>
        <div class="subscription-content col-sm" style="margin-top: 8px;">
            <div class="subtite" >
                <p style="font-size:28px; font-weight: 700;">{{t(`clients.company.subscription.type.${type}`)}}</p>
            </div>
            <div class="subtite infoText" >
                <p style="font-size:14px;">{{getInfoText}}</p>
            </div>
            <div class="staffle">
                <div v-if="type === 'free'">
                    <div class="col-sm payment-option" :class="[{'active': sub.type === type}, `payment-option-${color}`]" @click="setThisSubscription(type, 1)" style="font-size: 20px; text-align: center;">{{t('clients.company.subscription.choose.option')}}</div>
                </div>
                <div v-else>
                    <div class="col-sm payment-option" :class="[{'active': sub.id === option.id && sub.type === type, 'custom-subscription': option.custom_subscription}, `payment-option-${color}`]" v-for="option in staffleOptions" :key="option.id" @click="setThisSubscription(type, option.id, option.subtype)">
                        <i data-v-33eddb56="" class="fal fa-boxes has-tooltip" style="padding-right:8px;" data-original-title="null"></i>
                        <span v-if="option.subtype === 'fixed'">0 - {{option.max_sync}}</span>
                        <span v-if="option.subtype === 'request'">{{option.max_sync}}+</span>
                        <div style="float:right;">
                            <span style="font-size:20px; font-weight:normal;" v-if="option.subtype === 'fixed'">&euro; {{option.price}}</span>
                            <span style="font-size:20px; font-weight:normal;" v-if="option.subtype === 'request'">Op aanvraag</span>
                        </div>
                    </div>
                    <div class="col-sm payment-option" v-if="sub.type === type && sub.subtype === 'request'">
                        <input type='number' class="payment-option-input" value="15000" @input="$emit('changeRequestedAmount', $event.target.value)">
                    </div>
                    <div v-if="type === 'yearly'" style="text-align: center; clear: both; margin-top: 10px; margin-bottom: 10px;">
                        <a @click="paymentIntervalToggle" style="display: block;" v-if="paymentInterval === 'month'">{{ t('general.payment.yearly') }}</a>
                        <a @click="paymentIntervalToggle" style="display: block;" v-if="paymentInterval === 'year'">{{ t('general.payment.monthly') }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'SubscriptionPlan',

    components: {

    },
    props: {
        imgIcon: {
            type: String,
            default: 'fa-heart',
        },

        color: {
            type: String,
            default: '',
        },

        type: {
            type: String,
            default: 'free',
        },

        active: {
            type: Boolean,
            default: false,
        },

        options: {
            type: Object,
        },

        sub: {
            type: Object,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        paymentIntervalOptions: {
            type: Array,
            required: false,
            default: () => [],
        },
        requestedAmount: {
            type: Number,
            required: false,
            default: 0,
        },
    },

    data() {
        return {
            client: {},
            clientLoaded: false,
            submittingIsLoading: false,
            paymentInterval: this.paymentIntervalOptions[0]
        };
    },

    created() {

    },

    methods: {
        paymentIntervalToggle() {
            if (this.paymentInterval === 'month') {
                this.paymentInterval = 'year';
            } else if (this.paymentInterval === 'year') {
                this.paymentInterval = 'month';
            }
            this.$emit('setPaymentInterval', this.paymentInterval);
        },
        setThisSubscription($event, option, subtype) {
            this.$emit('setActiveSub', $event, option, subtype);
            this.$emit('setPaymentInterval', this.paymentInterval);
        },
    },

    computed: {
        staffleOptions() {
            if (this.paymentInterval === 'month') {
                return this.options.yearly;
            } else if (this.paymentInterval === 'year') {
                return this.options.yearly_once;
            }

            return this.options[this.paymentInterval];
        },
        getInfoText() {
            if (this.type === 'once') {
                return this.$translate.text('clients.company.subscription.once.description');
            } if (this.type === 'yearly') {
                return this.$translate.text('clients.company.subscription.yearly.description');
            }
            return this.$translate.text('clients.company.subscription.free.description');
        },

        // calculateOptions() {
        //     let price = 0;
        //     const array = [];
        //     this.options.forEach(item => {
        //         if (price !== 0) {
        //             // eslint-disable-next-line
        //             price = price + 1;
        //         }
        //         const test = {
        //             name: item.name,
        //             price: item.price,
        //             products: `${price} - ${item.products}`,
        //         };
        //         array.push(test);
        //         price = item.products;
        //     });

        //     return array;
        // },


    },
};
</script>
<style lang="scss" scoped>

.disabled {
    opacity: 0.3;
    pointer-events:none;
}
.subscription-plan {
    background-color: white;
    border: 1px solid white;
    margin: 8px;
    border-radius: 5px;
    transition: 0.6s;
}

.subscription-plan-pink.active {
    border: 1px solid #F879C3;
    border-radius: 5px;
}

.subscription-plan-green.active {
    border: 1px solid #86DEB7;
    border-radius: 5px;
}

.subscription-plan-yellow.active {
    border: 1px solid #FECB18;
    border-radius: 5px;
}

.payment-option-pink.active {
    background: #F879C3 0% 0% no-repeat padding-box;
}

.payment-option-green.active {
    background: #86DEB7 0% 0% no-repeat padding-box;
}

.payment-option-yellow.active {
    background: #FECB18 0% 0% no-repeat padding-box;
}

.subscription-plan:first-child {
    margin-left:0px;
}

.subscription-plan:last-child {
    margin-right:0px;
}

.subscription-logo {
    text-align: center;
    padding-top: 20px;
}

.pink {
    color: #F879C3;
}

.green {
    color: #86DEB7;
}

.yellow {
    color: #FECB18;
}

.subtite {
    text-align: center;
}

.infoText {
    height: 50px;
}

.payment-option {
    height: 50px;
    background: #F4F6F8 0% 0% no-repeat padding-box;
    border-radius: 5px;
    margin-top: 4px;
    line-height: 50px;
    text-align: left;
    transition: 0.3s;
    cursor: pointer;
}

.payment-option-pink:hover {
    background: #F879C3 0% 0% no-repeat padding-box;
}

.payment-option-green:hover {
    background: #86DEB7 0% 0% no-repeat padding-box;
}

.payment-option-yellow:hover {
    background: #FECB18 0% 0% no-repeat padding-box;
}

.payment-option.custom-subscription:not(.active) {
    background: #b7ebd5 0% 0% no-repeat padding-box;
}

.payment-option:last-child {
    margin-bottom: 8px;
}

.payment-option-input {
    border-radius: 4px;
    padding: 12px 16px;
    border: 0;
    width: 100%;
    margin: 0;
    color: #1F2833;
}
</style>
